import React from "react";
import { Download, Linkedin, Mail } from "lucide-react";
import { profile } from "../mock";
import { useRole } from "../context/RoleContext";

const Footer = () => {
  const { footer } = useRole();
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/5 bg-[#08080A]"
    >
      <div className="palette-rail absolute top-0 left-0 right-0 h-[2px] opacity-70" aria-hidden />
      <div className="container-x py-14">
        <div className="grid md:grid-cols-12 gap-8">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full breathe" style={{ backgroundColor: "#FF8A5B" }} />
              <span className="display text-[16px] text-[#FFF3E9]">{profile.name}</span>
            </div>
            <p data-testid="footer-bio" className="text-[14px] text-[#8A8A90] max-w-md leading-relaxed">
              {footer}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-3">Elsewhere</div>
            <ul className="space-y-2 text-[14px]">
              <li>
                <a
                  href={profile.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-[#FFD2A6] hover:text-[#FF8A5B] transition-colors"
                >
                  <Linkedin className="w-3.5 h-3.5" /> LinkedIn
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${profile.email}`}
                  className="inline-flex items-center gap-2 text-[#FFD2A6] hover:text-[#FF8A5B] transition-colors"
                >
                  <Mail className="w-3.5 h-3.5" /> Email
                </a>
              </li>
              <li>
                <a
                  href={profile.cv}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-[#FFD2A6] hover:text-[#FF8A5B] transition-colors"
                >
                  <Download className="w-3.5 h-3.5" /> CV (PDF)
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-3">Colophon</div>
            <p className="text-[13px] text-[#8B7B6E] leading-relaxed">
              Set in Space Grotesk, Outfit & Instrument Serif. Built with care in 2026.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="mono text-[11px] text-[#8B7B6E] tracking-wider">
            © {new Date().getFullYear()} — TANMAY AGARWAL · ALL RIGHTS RESERVED.
          </p>
          <p className="mono text-[11px] text-[#8B7B6E] tracking-wider">
            v2.0 — {new Date().toLocaleDateString("en-US", { month: "short", year: "numeric" })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
